import { render, staticRenderFns } from "./actionPlan.vue?vue&type=template&id=2252f70a&scoped=true&"
import script from "./actionPlan.vue?vue&type=script&lang=js&"
export * from "./actionPlan.vue?vue&type=script&lang=js&"
import style0 from "./actionPlan.vue?vue&type=style&index=0&id=2252f70a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252f70a",
  null
  
)

export default component.exports